import styled from "styled-components";

export default styled.span`
  background: #ccc;
  border-radius: 50%;
  color: white;
  box-shadow: 2px 3px 3px 0px rgba(0, 0, 0, 0.4);
  text-shadow: 1px 1px 0 #333;
  text-align: center;
  align-items: center;
  display: flex;
  justify-content: center;
  width: 20px;
  height: 20px;
  font-size: 14px;
  margin-right: 10px;
`;
